import { useContext } from "react";
import { useHistory } from "react-router-dom";

import { TInvitationStatus } from "@/data/invitations";
import { ISessionUser } from "@/data/session";
import { SessionContext } from "@/infrastructure/Session";
import { router } from "@/views/router";

export const useCreateSession = () => {
  const { create } = useContext(SessionContext);
  const history = useHistory();

  const createSession = async (sessionUser: ISessionUser) => {
    create(sessionUser, async () => {
      const pendingProfiles = sessionUser.consultantProfiles.filter(
        cp => cp.status === TInvitationStatus.PENDING && !cp.requestToJoin,
      );

      const storedRedirectUrl = localStorage.getItem("redirectUrl");

      const path =
        pendingProfiles.length > 0
          ? router.get("profiles-list").path
          : localStorage.getItem("redirectUrl") || router.get("dashboard").path;

      if (storedRedirectUrl) {
        localStorage.removeItem("redirectUrl");
      }

      history.push(path, { pendingProfiles, firstName: sessionUser.firstName });
    });
  };
  return {
    createSession,
  };
};
